<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Característica">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="_id" placeholder="_ID" v-model="form._id" disabled/>
                  <label for="_id">_ID</label>
                </div>
              </b-col> -->
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                    multiple
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="code" placeholder="Código" v-model="form.code"/>
                  <label for="code">Código</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtBr" placeholder="Nome PT-BR" v-model="form.namePtBr" />
                  <label for="name">Nome PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEnEu" placeholder="Nome EN-EU" v-model="form.nameEnEu" />
                  <label for="name">Nome EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsEs" placeholder="Nome ES-ES" v-model="form.nameEsEs" />
                  <label for="name">Nome ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsAr" placeholder="Nome ES-AR" v-model="form.nameEsAr" />
                  <label for="name">Nome ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtPt" placeholder="Nome PT-PT" v-model="form.namePtPt" />
                  <label for="name">Nome PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameZhCn" placeholder="Nome Zh-Cn" v-model="form.nameZhCn" />
                  <label for="name">Nome Zh-CN</label>
                </div>
              </b-col>
              
              <b-col md="12"></b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import characteristicService from "@/providers/characteristicService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      form: {
        _id: "",
        code: "",
        namePtBr: "",
        nameEnEu: "",
        nameEsEs: "",
        nameEsAr: "",
        namePtPt: "",
        nameZhCn: "",
        origin: [],
        active: true,
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Nova Caracteristica');
    this.loadData();
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
      this.getCharacteristicDetail();
    }

  },
  watch: {
    "form.namePtBr"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Nova Caracteristica');
      }
    }
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_CHARACTERISTIC);
    },
    onSubmit() {
      characteristicService
        .registerCharacteristic(this.form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getCharacteristicDetail() {
      const params = new URLSearchParams();
      characteristicService
        .getCharacteristicDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.code = res.code;
          this.form.namePtBr = res.namePtBr;
          this.form.nameEnEu = res.nameEnEu;
          this.form.nameEsEs = res.nameEsEs;
          this.form.nameEsAr = res.nameEsAr;
          this.form.namePtPt = res.namePtPt;
          this.form.nameZhCn = res.nameZhCn;
          this.form.origin = res.origin;
          this.form.active = res.active;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      dropdownService
        .getAllOrigin(new URLSearchParams())
        .then((res) => {
          this.origins = res;
          if (this.isUpdate) {
            this.getCharacteristicDetail();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect,
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>